import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

import { entityTypeOptions, mediaTypeOptions } from 'v3/pages/Reports/ExpiredDocuments/controller';

import { Select, Text, Button, Input, Modal } from 'v3/components';

import {
  fetchDriver,
  fetchVehicle,
  fetchWagons,
  fetchVehiclesByIds,
  fetchWagonsByIds,
  fetchDriverByIds,
} from 'utils/fetches';

export default function ExpiredLoadsFilter({
  onChange,
  loading,
  showAdvancedFiltersModal,
  setShowAdvancedFiltersModal,
  setQtdAdvancedFilters,
  queryParams,
  setAdvancedFilters,
  advancedFilters,
}) {
  const navigate = useNavigate();
  const [error, setError] = useState({});

  useEffect(() => {
    const timeout = setTimeout(() => {
      navigate({ search: queryParams.toString() });
    }, 100);

    return () => {
      clearTimeout(timeout);
    };
  }, [advancedFilters]);

  useEffect(() => {
    const isNotEmpty = (value) =>
      value !== null && value !== undefined && value !== '' && value !== 0;

    const validateAdvancedFilters = {
      drivers: advancedFilters?.drivers?.length,
      vehicles: advancedFilters?.vehicles?.length,
      wagons: advancedFilters?.wagons?.length,
      media_type: advancedFilters?.media_type,
    };

    setQtdAdvancedFilters(Object.values(validateAdvancedFilters).filter(isNotEmpty).length);
  }, [advancedFilters]);

  const handlerAdvancedFilters = () => {
    onChange();
    setShowAdvancedFiltersModal(false);
  };

  async function handleInitializeParams() {
    const startDate = moment().subtract(120, 'days').format('YYYY-MM-DD');
    const endDate = moment().format('YYYY-MM-DD');

    if (queryParams.has('start_date')) {
      setAdvancedFilters((old) => ({
        ...old,
        start_date: moment(queryParams.get('start_date')).format('YYYY-MM-DD'),
      }));
    } else {
      queryParams.set('start_date', startDate);
      setAdvancedFilters((old) => ({ ...old, start_date: startDate }));
    }

    if (queryParams.has('end_date')) {
      setAdvancedFilters((old) => ({
        ...old,
        end_date: moment(queryParams.get('end_date')).format('YYYY-MM-DD'),
      }));
    } else {
      queryParams.set('end_date', endDate);
      setAdvancedFilters((old) => ({ ...old, end_date: endDate }));
    }

    if (queryParams.has('drivers[]')) {
      const driverIds = queryParams.getAll('drivers[]').map((driver) => Number(driver));
      const { drivers } = await fetchDriverByIds(driverIds);
      setAdvancedFilters((old) => ({ ...old, drivers }));
    }

    if (queryParams.has('vehicles[]')) {
      const vehiclesIds = queryParams.getAll('vehicles[]').map((vehicle) => Number(vehicle));
      const AllVehicles = await fetchVehiclesByIds(vehiclesIds);
      setAdvancedFilters((old) => ({ ...old, vehicles: AllVehicles }));
    }

    if (queryParams.has('wagons[]')) {
      const wagonsIds = queryParams.getAll('wagons[]').map((wagon) => Number(wagon));
      const AllWagons = await fetchWagonsByIds(wagonsIds);
      setAdvancedFilters((old) => ({ ...old, wagons: AllWagons }));
    }

    if (queryParams.has('entity_type')) {
      const entityType = entityTypeOptions().find(
        (item) => item.slug === queryParams.get('entity_type'),
      );
      setAdvancedFilters((old) => ({ ...old, entity_type: entityType }));
    }

    if (queryParams.has('media_type')) {
      const mediaType = mediaTypeOptions().find(
        (item) => item.slug === queryParams.get('media_type'),
      );
      setAdvancedFilters((old) => ({ ...old, media_type: mediaType }));
    }
  }

  useEffect(() => {
    handleInitializeParams();
  }, []);

  return (
    <>
      <Modal
        heading={
          <Text color="dark" type="header">
            Filtro Avançado
          </Text>
        }
        show={showAdvancedFiltersModal}
        handleClose={() => {
          setShowAdvancedFiltersModal(false);
        }}
        body={
          <Row>
            <Col md={4} xs={12} className="mb-3">
              <Select.Async
                modalHeading="Selecione um motorista"
                modalBodyTitle="Motoristas:"
                label="Motorista"
                onSearch={fetchDriver}
                value={advancedFilters?.drivers}
                onChange={(value) => {
                  if (Array.isArray(value)) {
                    queryParams.delete('drivers[]');
                    value
                      .map((driver) => driver.id)
                      .forEach((processed) => {
                        queryParams.append('drivers[]', processed);
                      });
                  } else {
                    queryParams.delete('drivers[]');
                  }
                  setAdvancedFilters((old) => ({ ...old, drivers: value }));
                }}
                horizontal
                multiple
                getOptionLabel={(option) => option.label}
                getOptionValue={(option) => option.id}
              />
            </Col>
            <Col md={4} xs={12} className="mb-3">
              <Select.Async
                modalHeading="Selecione um veiculo"
                modalBodyTitle="Veiculos:"
                label="Veiculo"
                onSearch={fetchVehicle}
                value={advancedFilters?.vehicles}
                onChange={(value) => {
                  if (Array.isArray(value)) {
                    queryParams.delete('vehicles[]');
                    value
                      .map((vehicle) => vehicle.id)
                      .forEach((processed) => {
                        queryParams.append('vehicles[]', processed);
                      });
                  } else {
                    queryParams.delete('vehicles[]');
                  }
                  setAdvancedFilters((old) => ({ ...old, vehicles: value }));
                }}
                multiple
                horizontal
                getOptionLabel={(option) => option.plate}
                getOptionValue={(option) => option.id}
              />
            </Col>
            <Col md={4} xs={12} className="mb-3">
              <Select.Async
                modalHeading="Selecione um implemento"
                modalBodyTitle="Implementos:"
                label="Implemento"
                onSearch={fetchWagons}
                value={advancedFilters?.wagons}
                onChange={(value) => {
                  if (Array.isArray(value)) {
                    queryParams.delete('wagons[]');
                    value
                      .map((wagon) => wagon.id)
                      .forEach((processed) => {
                        queryParams.append('wagons[]', processed);
                      });
                  } else {
                    queryParams.delete('wagons[]');
                  }
                  setAdvancedFilters((old) => ({ ...old, wagons: value }));
                }}
                horizontal
                multiple
                getOptionLabel={(option) => option.plate}
                getOptionValue={(option) => option.id}
              />
            </Col>
            <Col md={4} xs={12} className="mb-3">
              <Select
                label="Tipo de anexo"
                labelColor="#fff"
                options={mediaTypeOptions()}
                value={advancedFilters?.media_type}
                getOptionLabel={(option) => option?.name}
                getOptionValue={(option) => option?.id}
                onChange={(event) => {
                  setAdvancedFilters((old) => ({ ...old, media_type: event }));
                  if (event === null || event == '') {
                    queryParams.delete('media_type');
                  } else {
                    queryParams.set('media_type', event.slug);
                  }
                }}
              />
            </Col>
          </Row>
        }
        footer={
          <Row>
            <Col>
              <Button size="sm" onClick={() => handlerAdvancedFilters()} disabled={loading}>
                <Text weight={500}>Filtrar</Text>
              </Button>
            </Col>
          </Row>
        }
      />

      <Col md={3} xs={12} className="mb-3">
        <Input
          type="date"
          value={advancedFilters?.start_date}
          label="Data inicial"
          labelColor="#fff"
          onChange={(event) => {
            setError({ ...error, start_date: null });
            setAdvancedFilters((old) => ({ ...old, start_date: event.target?.value }));
            if (event.target.value === null || event.target.value == '') {
              queryParams.delete('start_date');
            } else {
              queryParams.set('start_date', moment(event.target.value).format('YYYY-MM-DD'));
            }
          }}
          error={error.start_date}
        />
      </Col>

      <Col md={3} xs={12} className="mb-3">
        <Input
          type="date"
          value={advancedFilters?.end_date || queryParams.get('end_date')}
          label="Data final"
          labelColor="#fff"
          onChange={(event) => {
            setError({ ...error, end_date: null });
            setAdvancedFilters((old) => ({ ...old, end_date: event.target?.value }));
            if (event.target.value === null || event.target.value == '') {
              queryParams.delete('end_date');
            } else {
              queryParams.set('end_date', moment(event.target.value).format('YYYY-MM-DD'));
            }
          }}
          error={error.end_date}
        />
      </Col>
      <Col md={3} xs={12} className="mb-3">
        <Select
          label="Tipos de registro"
          labelTextColor="#fff"
          options={entityTypeOptions()}
          value={advancedFilters?.entity_type}
          getOptionLabel={(option) => option?.name}
          getOptionValue={(option) => option?.id}
          onChange={(event) => {
            setAdvancedFilters((old) => ({ ...old, entity_type: event }));
            if (event === null || event == '') {
              queryParams.delete('entity_type');
            } else {
              queryParams.set('entity_type', event.slug);
            }
          }}
        />
      </Col>

      <Col md={1} xs={12} className="mt-4">
        <Button
          variant="primary"
          onClick={() => onChange()}
          loading={loading}
          height="fit-content"
          className="mt-1"
          disabled={loading}
        >
          <Text type="regular" weight="500">
            Filtrar
          </Text>
        </Button>
      </Col>
    </>
  );
}
